var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchaseBlackOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    stroke: "#1E1E1E",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.26638 9.0396C8.80154 9.30107 8.45231 9.57762 8.18497 9.83909C7.83574 9.43934 7.40222 8.65745 7.40222 8.08423C7.40222 7.33753 8.51734 6 12.8574 6C15.7187 6 17 7.4406 17 9.59522C17 12.1471 15.1864 14.1106 11.3593 14.3545C10.9258 17.6028 10.4273 18 8.96291 18C8.06455 18 7.36609 17.653 7 17.0974C8.24759 15.5336 8.97977 11.7825 9.26156 9.0396H9.26638ZM11.6122 12.0088C13.3102 11.8001 13.9412 10.983 13.9412 9.64802C13.9412 8.86612 13.4933 8.2577 12.5949 8.2577C12.3781 8.2577 12.1614 8.2753 11.9639 8.2929C11.8627 9.68322 11.7134 10.9679 11.6146 12.0088H11.6122Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseBlackOutlined);
export default __webpack_public_path__ + "static/media/purchase_black_outlined.e201638b5338d2c79a99db2510c5f98c.svg";
export { ForwardRef as ReactComponent };